import {
  OPEN_CREATE_EVENTSLIST,
  CLOSE_CREATE_EVENTSLIST,
  SET_EVENTSLIST,
  SET_EVENTSLIST_PENDING,
  SET_CREATE_NEW_EVENT_SUCCESS,
  SET_NEW_EVENT_ID,
  SET_ADDED_QUESTIONS_LIST,
  SET_NEWEVENT_DATA,
  SET_QUESTIONS_REDIRECT,
  SET_EDIT_QUESTION_DATA,
  SET_IS_GET_ADDED_QUESTION_LIST_PENDING,
  SET_IS_GET_EVENT_DATA_PENDING,
  SET_IS_GET_EDIT_QUESTION_DATA_PENDING,
  SET_IS_CREATE_NEW_EVENT_PENDING,
  SET_IS_ADD_QUESTION_DATA_PENDING,
  OPEN_ADD_ORGANIZER,
  CLOSE_ADD_ORGANIZER,
  SET_USER_ORGANIZER,
  SET_ORGANIZER_PENDING,
  SET_ORGANIZER_LIST,
  SET_EVENT_ORGANIZER_PENDING,
  OPEN_ADD_EVALUATOR,
  CLOSE_ADD_EVALUATOR,
  GET_EVENT_USERS_PENDING,
  SET_EVENT_USERS,
  SET_EVALUATORS_PENDING,
  SET_EVALUATORS_LIST,
  SET_USER_EVALUATOR,
  SET_EVENT_EVALUATORS_PENDING,
  SET_DELETE_ORGANIZER_PENDING,
  SET_DELETE_EVALUATOR_PENDING,
  SET_UPLOAD_ANSWERVI_VISIBLE,
  INITIALIZE_EDITQUESTIONDATA,
  SET_AUTOEVAL_RESULTS,
  SET_AUTOEVAL_RESULTS_PENDING,
  SET_CURRENT_QUESTIONID,
  SET_AUTOEVAL_INPUTS_VISIBLE,
  SET_UPLOAD_ANSWER_PENDING,
  SET_SAVE_TESTCASE,
  SET_EVENT_EDITED_STATUS,
  SET_IS_EVALUATED,
  SET_CONFIG_FILE_PENDING
} from "../constants/CreateEvents.constants.js";

const initialstate: createEventState = {
  isEventEdited:false,
  isSaveTCPending:false,
  isCreateEventsList: false,
  eventsList: [],
  isUploadAnswerPending: false,
  isAutoEvalResultsPending: false,
  isGetEventsPending: false,
  isNewEventCreated: false,
  newEventID: "",
  addedQuestions: [],
  editQuestionData: {
    id: null,
    eventId: null,
    questionTitle: "",
    question: "",
    answer: "",
    points: 0,
    isEvaluated:false,
    testcases: [],
    error: null,
    ansTemplateDownloadLink: null,
    isUploadAnswerVisible: false,
    isAutoEvalInputs: false,
  },
  newEventData: {
    eventName: "",
    startDateTime: null,
    endDateTime: null,
    isParallel: true,
    evaluationType: 0,
    description: "",
    inCorrectMinutes: 1,
    inCorrectSeconds: 0,
    reUploadMinutes: 1,
    reUploadSeconds: 0,
    isPublished: false,
    timeTakenWeightage: 0,
    executionTimeWeightage: 0,
    codeQualityWeightage: 0,
    memoryTakenWeightage: 0,
    isGame: false
  },
  isRedirectBack: false,
  isGetAddedQuestionListPending: false,
  isGetEventDataPending: false,
  isGetEditQuestionDataPending: false,
  isCreateNewEventPending: false,
  isAddQuestionDataPending: false,
  isOpenAddOrganizer: false,
  selectedOrganizer: null,
  setOrganizerPending: false,
  organizerList: [],
  setEventOrganizerPending: false,
  isOpenAddEvaluator: false,
  isGetEventUserPending: false,
  eventUsers: [],
  isGetEvaluatorsPending: false,
  evaluatorsList: [],
  selectedEvaluator: null,
  isSetEvaluatorPending: false,
  isDeleteOrganizerPending: false,
  isDeleteEvaluatorPending: false,
  isConfigFilePending: false
};

export default (
  localState: createEventState = initialstate,
  action: Action
): createEventState => {
  switch (action.type) {
    case SET_IS_EVALUATED:
      return{
        ...localState,
        editQuestionData:{
          ...localState.editQuestionData,
          isEvaluated: action.payload,
        }
      }
    case SET_EVENT_EDITED_STATUS:
      return{
        ...localState,
        isEventEdited: action.payload
      }
    case SET_SAVE_TESTCASE:
      return{
        ...localState,
        isSaveTCPending:action.payload,
      }
    case SET_AUTOEVAL_INPUTS_VISIBLE:
      return {
        ...localState,
        editQuestionData: {
          ...localState.editQuestionData,
          isAutoEvalInputs: action.payload,
        },
      };
    
    case SET_UPLOAD_ANSWER_PENDING:
      return{
        ...localState,
        isUploadAnswerPending : action.payload
      }

    case SET_CURRENT_QUESTIONID:
      return {
        ...localState,
        editQuestionData: {
          ...localState.editQuestionData,
          id: action.payload,
        },
      };

    case SET_AUTOEVAL_RESULTS:
      return {
        ...localState,
        editQuestionData: {
          ...localState.editQuestionData,
          testcases: action.payload.testcases,
          error: action.payload.error,
          isEvaluated: action.payload.isEvaluated
        },
      };

    case SET_AUTOEVAL_RESULTS_PENDING:
      return {
        ...localState,
        isAutoEvalResultsPending: action.payload,
      };

    case INITIALIZE_EDITQUESTIONDATA: {
      return {
        ...localState,
        editQuestionData: initialstate.editQuestionData,
      };
    }
    case SET_UPLOAD_ANSWERVI_VISIBLE: {
      return {
        ...localState,
        editQuestionData: {
          ...localState.editQuestionData,
          isUploadAnswerVisible: action.payload,
        },
      };
    }
    case OPEN_CREATE_EVENTSLIST: {
      return {
        ...localState,
        isCreateEventsList: true,
      };
    }
    case CLOSE_CREATE_EVENTSLIST: {
      return {
        ...localState,
        isCreateEventsList: false,
      };
    }
    case SET_EVENTSLIST: {
      const { eventsList } = action.payload;
      return {
        ...localState,
        eventsList: eventsList,
      };
    }
    case SET_EVENTSLIST_PENDING: {
      return {
        ...localState,
        isGetEventsPending: action.payload,
      };
    }
    case SET_CREATE_NEW_EVENT_SUCCESS: {
      return {
        ...localState,
        isNewEventCreated: true,
      };
    }
    case SET_NEW_EVENT_ID: {
      const { newEventID } = action.payload;
      return {
        ...localState,
        newEventID: newEventID,
      };
    }
    case SET_ADDED_QUESTIONS_LIST: {
      return {
        ...localState,
        addedQuestions: action.payload,
      };
    }
    case SET_NEWEVENT_DATA: {
      return {
        ...localState,
        newEventData: action.payload,
      };
    }
    case SET_QUESTIONS_REDIRECT: {
      return {
        ...localState,
        isRedirectBack: action.payload,
      };
    }
    case SET_EDIT_QUESTION_DATA: {
      return {
        ...localState,
        editQuestionData: action.payload,
      };
    }
    case SET_IS_GET_ADDED_QUESTION_LIST_PENDING: {
      return {
        ...localState,
        isGetAddedQuestionListPending: action.payload,
      };
    }

    case SET_IS_GET_EVENT_DATA_PENDING: {
      return {
        ...localState,
        isGetEventDataPending: action.payload,
      };
    }

    case SET_IS_GET_EDIT_QUESTION_DATA_PENDING: {
      return {
        ...localState,
        isGetEditQuestionDataPending: action.payload,
      };
    }

    case SET_IS_CREATE_NEW_EVENT_PENDING: {
      return {
        ...localState,
        isCreateNewEventPending: action.payload,
      };
    }

    case SET_IS_ADD_QUESTION_DATA_PENDING: {
      return {
        ...localState,
        isAddQuestionDataPending: action.payload,
      };
    }
    case OPEN_ADD_ORGANIZER: {
      return {
        ...localState,
        isOpenAddOrganizer: action.payload,
      };
    }
    case CLOSE_ADD_ORGANIZER: {
      return {
        ...localState,
        isOpenAddOrganizer: action.payload,
      };
    }
    case SET_USER_ORGANIZER: {
      return {
        ...localState,
        selectedOrganizer: action.payload,
      };
    }
    case SET_ORGANIZER_PENDING: {
      return {
        ...localState,
        setOrganizerPending: action.payload,
      };
    }
    case SET_ORGANIZER_LIST: {
      return {
        ...localState,
        organizerList: action.payload,
      };
    }
    case SET_EVENT_ORGANIZER_PENDING: {
      return {
        ...localState,
        setEventOrganizerPending: action.payload,
      };
    }
    case OPEN_ADD_EVALUATOR: {
      return {
        ...localState,
        isOpenAddEvaluator: action.payload,
      };
    }
    case CLOSE_ADD_EVALUATOR: {
      return {
        ...localState,
        isOpenAddEvaluator: action.payload,
      };
    }
    case GET_EVENT_USERS_PENDING: {
      return {
        ...localState,
        isGetEventUserPending: action.payload,
      };
    }
    case SET_EVENT_USERS: {
      return {
        ...localState,
        eventUsers: action.payload,
      };
    }
    case SET_EVALUATORS_PENDING: {
      return {
        ...localState,
        isGetEvaluatorsPending: action.payload,
      };
    }
    case SET_EVALUATORS_LIST: {
      return {
        ...localState,
        evaluatorsList: action.payload,
      };
    }
    case SET_USER_EVALUATOR: {
      return {
        ...localState,
        selectedEvaluator: action.payload,
      };
    }
    case SET_EVENT_EVALUATORS_PENDING: {
      return {
        ...localState,
        isSetEvaluatorPending: action.payload,
      };
    }
    case SET_DELETE_ORGANIZER_PENDING: {
      return {
        ...localState,
        isDeleteOrganizerPending: action.payload,
      };
    }
    case SET_DELETE_EVALUATOR_PENDING: {
      return {
        ...localState,
        isDeleteEvaluatorPending: action.payload,
      };
    }
    case SET_CONFIG_FILE_PENDING: {
      return {
        ...localState,
        isConfigFilePending: action.payload
      }
    }
    default: {
      return localState;
    }
  }
};
